import { GET_CONTRIES_LIST } from '../Actions/ActionTypes/ActionTypes';

const initialState = {
  countriesList: [],
  alpha2codeCountries: [],
  phoneTypeList: [],
  lastLanguage: null
};

export default function countriesList(state = initialState, action) {
  switch (action.type) {
    case GET_CONTRIES_LIST:
      if (!action.payload) return state;

      return {
        ...state,
        countriesList: action.payload,
        alpha2codeCountries: action.alpha2codeCountries,
        phoneTypeList: action.phoneTypeList,
        lastLanguage: action.languageId
      };
    default:
      return state;
  }
}
